import { Alert, Skeleton } from "antd"
import { useRainforestMerchantStatusQuery } from "../../../domain/invoicing/rainforestQueries"
import { useState } from "react"
import MerchantApplicationDrawer from "./MerchantApplicationDrawer"
import { useHideApprovedApplicationMutation } from "../../../domain/invoicing/settings/invoicingSettingsQueries"
import MerchantStatus from "./MerchantStatus"
import useFeatureFlag from "../../../hooks/useFeatureFlag"
import MerchantApplicationModal from "../../MerchantApplication/MerchantApplicationModal"
import { MerchantStatusData } from "../../../domain/invoicing/rainforest"

type Props = {
  hideApprovedApplication: boolean
}

export const setupSynkedUPPaymentsHasContent = (
  merchantStatusData: MerchantStatusData | undefined,
  hideApprovedApplication: boolean
): boolean => {
  return !(merchantStatusData?.merchantStatus === 'ACTIVE' && hideApprovedApplication)
}

const SetupSynkedUPPayments = ({ hideApprovedApplication }: Props) => {
  const merchantStatusQuery = useRainforestMerchantStatusQuery()
  const hideApprovedApplicationMutation = useHideApprovedApplicationMutation()
  const [isApplicationDrawerOpen, setIsApplicationDrawerOpen] = useState(false)
  const [isNativeApplicationOpen, setIsNativeApplicationOpen] = useState(false)
  const [wasApplicationSubmitted, setWasApplicationSubmitted] = useState(false)
  const isNativeApplicationEnabled = useFeatureFlag('dev-native-merchant-application')
  const applicationStatus = wasApplicationSubmitted ? 'PROCESSING' : merchantStatusQuery.data?.applicationStatus ?? ''

  if (merchantStatusQuery.isLoading) {
    return <Skeleton active />
  }

  if (merchantStatusQuery.isError) {
    return <Alert type="error" message="Error loading SynkedUP Payments status. Please try again later." />
  }

  if (!setupSynkedUPPaymentsHasContent(merchantStatusQuery.data, hideApprovedApplication)) {
    return null
  }

  const handleOpenApplication = () => {
    if (isNativeApplicationEnabled) {
      setIsNativeApplicationOpen(true)
    } else {
      setIsApplicationDrawerOpen(true)
    }
  }

  const handleApplicationSubmitted = () => {
    setWasApplicationSubmitted(true)
    setIsApplicationDrawerOpen(false)
    setIsNativeApplicationOpen(false)
  }

  return <>
    <MerchantStatus
      applicationStatus={applicationStatus}
      merchantStatusData={merchantStatusQuery.data}
      onStartApplication={handleOpenApplication}
      onManageApplication={handleOpenApplication}
      onGotIt={() => hideApprovedApplicationMutation.mutate()}
      onContactSupport={() => location.href = 'mailto:support@synkedup.com'}
    />
    <MerchantApplicationDrawer
      isOpen={isApplicationDrawerOpen}
      onClose={() => setIsApplicationDrawerOpen(false)}
      merchantData={merchantStatusQuery.data}
      onApplicationSubmitted={handleApplicationSubmitted}
    />
    <MerchantApplicationModal
      open={isNativeApplicationOpen}
      onClose={() => setIsNativeApplicationOpen(false)}
      onApplicationSubmitted={handleApplicationSubmitted}
    />
  </>
}

export default SetupSynkedUPPayments